import {Injectable} from '@angular/core';
//  {wsMeta} from '../../AngularJS/app/webServicesMeta';

const gettext = a => a;

@Injectable()
export class UserMenuService {
  public sections: { header: string; items: { header: string; uiSref: string }[] }[] = [
    // {
    //   header: gettext('configurations'),
    //   items: [{
    //     header: 'events',
    //     uiSref: `${ROOT_STATE_NAME}.${APP_STATE_NAME}.${wsMeta.user.webService}.${wsMeta.userevent.resource.description.headerPlural}`
    //   },
    //     {
    //       header: 'notifyChannels',
    //       uiSref: `${ROOT_STATE_NAME}.${APP_STATE_NAME}.${wsMeta.user.webService}.${wsMeta.profileusernotify.resource.description.headerPlural}`
    //     }]
    // },
    /*
      {
        header: 'notifyChannels',
        items: []
      }
    */
  ];

  constructor() {
  }


}
